import { Button } from "@mui/material";
import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import headerLogo from "../Header/Images/header-logo.jpeg.png";
import "./HomePage.css";
import eodimg from "./12.jpg";

const HomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleGoToEodReport = () => {
    navigate("/eod-analytics");
    dispatch({ type: "SELECTED_ANALYTICS", payload: "eod-analytics" });
    dispatch({ type: "ACTIVE_BUTTON", payload: "Daily" });
  };

  const gotoEodReports = () => {
    navigate("/eod-reports");
  };
  const handleGoToIntradayAnalytics = () => {
    navigate("/intraday-analytics");
    dispatch({ type: "SELECTED_ANALYTICS", payload: "intraday-analytics" });
    dispatch({ type: "ACTIVE_BUTTON", payload: "Daily" });
  };

  const gotoTSH = () => {
    navigate("/tsh");
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    dispatch({ type: "SET_ISAUTHENTICATED", payload: false });
    dispatch({ type: "SET_AUTHTOKEN", payload: null });
    navigate("/login");
  };

  return (
    <div className="Header-component">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <img src={headerLogo} alt="headerLogo" className="header-logo" />
        <Button
          onClick={handleLogout}
          sx={{
            padding: "12px",
            marginRight: "20px",
            width: "auto",
            borderRadius: "10px",
            cursor: "pointer",
            backgroundColor: "lightgrey",
            border: 0,
            color: "black",
            fontSize: "10px",
          }}
        >
          SignOut
        </Button>
      </div>
      <div style={{ padding: "32px", display: "flex" }}>
        <Card sx={{ maxWidth: 345, marginRight: "16px" }}>
          <CardActionArea onClick={handleGoToEodReport}>
            <CardMedia
              component="img"
              height="140"
              image={eodimg}
              alt="green iguana"
            />
            <CardContent>
              <Typography gutterBottom variant="h6" component="div">
                EOD Analytics
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
        <Card sx={{ maxWidth: 345, marginRight: "16px" }}>
          <CardActionArea onClick={handleGoToIntradayAnalytics}>
            <CardMedia
              component="img"
              height="140"
              image={eodimg}
              alt="green iguana"
            />
            <CardContent>
              <Typography gutterBottom variant="h6" component="div">
                Intraday Analytics
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
        <Card sx={{ maxWidth: 345, marginRight: "16px" }}>
          <CardActionArea onClick={gotoEodReports}>
            <CardMedia
              component="img"
              height="140"
              image={eodimg}
              alt="green iguana"
            />
            <CardContent>
              <Typography gutterBottom variant="h6" component="div">
                EOD Reports
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
        <Card sx={{ maxWidth: 345 }}>
          <CardActionArea onClick={gotoTSH}>
            <CardMedia
              component="img"
              height="140"
              image={eodimg}
              alt="green iguana"
            />
            <CardContent>
              <Typography gutterBottom variant="h6" component="div">
                Top Stock History
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </div>
    </div>
  );
};

export default HomePage;
